import { logEvent } from "../util/Analytics";
import { saveItem } from "../util/LocalStorage";
export function setupThemeSwitch() {
    const themeSwitch = document.querySelector(".themeSwitch");
    themeSwitch.onclick = () => {
        const classList = document.documentElement.classList;
        const newClassName = document.documentElement.className =
            classList.contains("darkTheme") ? "extraDarkTheme" : classList.contains("extraDarkTheme") ? "" : "darkTheme";
        const theme = newClassName == "darkTheme" ? "dark" : newClassName == "extraDarkTheme" ? "extraDark" : "light";
        logEvent("theme_set", { theme: theme });
        saveItem("theme", theme);
    };
}
